import { GridSortItem } from "@mui/x-data-grid";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../../hooks/use-encounter-creation-gate";
import { ScreenerControllerApi } from "../../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  xTENANTID?: string;
  searchString?: string;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author [Atish Bagate]
 */
export const useGetAllScreenerType = ({
  pagination,
  gridSorting,
  xTENANTID,
  searchString,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });
  const pageSize = getPageSize("", pagination);

  const sortData = gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "all-screener-type-list",
      pageIndex,
      pageSize,
      gridSorting,
      xTENANTID,
      sortData,
      searchString,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled && !skip,
    queryFn: async () =>
      await new ScreenerControllerApi(getConfigObject())
        .getAllScreenerTypes(
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          searchString, // searchString
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
